// @scripts
import globalUi from './global-UI';
import { initializeServiceMocker } from './service-mocker';

const initializeApp = () => {
  const serviceMocker = initializeServiceMocker();
  globalThis.core = {
    globalUI: globalUi,
    serviceMocker
  };

  return globalThis.core;
};

export const {
  globalUI
} = initializeApp();

export default initializeApp;
